<template>
  <div ref="myElement" class="filterStatus">
    <p>{{ lang('状态(多选)') }}</p>
    <div class="btnBox">
      <van-button
        v-for="(item, i) in list"
        :key="i"
        :class="cur === item.value ? 'btnLight' : 'btn'"
        round
        :plain="true"
        :style="{ width: btnWidth, 'margin-right': btnMargin(i + 1) }"
        @click="() => click(item.value)"
      >
        {{ item.name }}
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, nextTick, watch } from 'vue'
import lang from '@/langs'
const myElement = ref(null)
const btnWidth = ref(0 + 'px')
const props = defineProps<{ tab: number }>()
const scoreList = [
  { name: lang('全部'), value: 0 },
  { name: lang('处理中'), value: 1 },
  { name: lang('已取消'), value: 2 },
  { name: lang('已驳回'), value: 4 },
  { name: lang('待确认'), value: 5 },
  { name: lang('已确认'), value: 6 }
]
const chargeList = [
  { name: lang('全部'), value: 0 },
  { name: lang('审核中'), value: 1 },
  { name: lang('成功'), value: 2 },
  { name: lang('失败'), value: 3 }
]
const list = ref(props.tab === 0 ? scoreList : chargeList)
const cur = ref<number>(0)
const click = (value: number) => {
  cur.value = value
  emits('click', cur.value)
}
watch(
  () => props.tab,
  (value) => {
    cur.value = 0
    if (value === 0) {
      list.value = scoreList
    } else {
      list.value = chargeList
    }
  },
  {
    immediate: true
  }
)
const emits = defineEmits(['click', 'reset'])
const btnMargin = (i: number) => {
  if (i % 3 === 0) {
    return 0
  } else {
    return '14px'
  }
}
onMounted(() => {
  nextTick(() => {
    const elementWidth = myElement.value.getBoundingClientRect().width
    console.log('元素宽度:', elementWidth)
    btnWidth.value = (elementWidth - 28) / 3 + 'px'
  })
})
</script>

<style scoped lang="less">
.filterStatus {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  > p {
    margin-bottom: 13px;
    color: rgba(60, 60, 60, 1);
    font-size: 14px;
    font-weight: 500;
  }
  .btnBox {
    .btn {
      color: rgba(60, 60, 60, 1);
      font-size: 14px;
      background: rgba(242, 242, 242, 1);
      border-color: rgba(242, 242, 242, 1);
      padding: 10px 15px;
      margin-bottom: 13px;
      height: auto;
    }
    .btnLight {
      color: rgba(255, 0, 0, 1);
      font-size: 14px;
      background: rgba(255, 0, 0, 0.08);
      border-color: rgba(255, 0, 0, 1);
      padding: 10px 15px;
      margin-bottom: 13px;
      height: auto;
    }
  }
}
</style>
